// import {  getNotLoginPwdRule} from "@/api/index";
import {  setCookie } from '@/utils/cookie';
import httpStatusCode from  "@/utils/httpStatusCode"
import {message} from "ant-design-vue";

import i18n from '@/utils/i18n';


// const languages = i18n.messages[i18n.locale]

export  default function checkNotLoginPassword(value,phonesn,type,callback){

    return getNotLoginData(value,phonesn,type,callback).then(res=> {

    })
}
function getNotLoginData(value,phonesn,type,callback) {
    return new Promise(function(resolve, reject) {
        let parms = {
            value :String(!phonesn?0:phonesn),
            type:type,
            password:value
        }
        setCookie('username', "0")
        // getNotLoginPwdRule(parms).then(res=> {
        //     if(res.code == httpStatusCode.StatusOK) {
        //         setCookie('username', phonesn)
        //         let languages;
        //         if(i18n.locale == 'en'){
        //             languages = i18n.messages.en
        //         }else{
        //             languages = i18n.messages.zh
        //         }
        //         if(res.message!= languages.utils.checkPwd.msg){
        //             callback(res.message)
        //             return
        //         }else {
        //             return callback();
        //         }
        //     } else {
        //         message.error(res.message)
        //         return
        //     }
        // })
    });
}